export const API_BASE_URL = import.meta.env.VITE_API_URL;
export const API_SOCKET_URL = import.meta.env.VITE_SOCKET_URL;

// Debug/Testing configuration
export const DEBUG_CONFIG = {
  SECRET_PASSWORD_HEADER: 'X-Secret-Password',
  SECRET_PASSWORD: import.meta.env.VITE_DEBUG_SECRET || 'debug_secret_2024',
} as const;
